export default __webpack_public_path__ + "static/media/foto_apply.13c2ac1b.jpg";